var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.367,
    height: 11.367,
    viewBox: "0 0 11.367 11.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12650",
    "data-name": "Grupo 12650",
    transform: "translate(-1104.543 -516.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12444",
    "data-name": "Grupo 12444",
    transform: "translate(1094.404 506.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(11.2 11.451)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_516",
    "data-name": "L\\xEDnea 516",
    x1: 9.246,
    y2: 9.246,
    transform: "translate(0 0)",
    fill: "#330072",
    stroke: "#330072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_517",
    "data-name": "L\\xEDnea 517",
    x2: 9.246,
    y2: 9.246,
    transform: "translate(0 0)",
    fill: "#330072",
    stroke: "#330072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseIcon);
export default __webpack_public_path__ + "static/media/xCloseIcon.9e339664838593563e6daa9bd3dddce5.svg";
export { ForwardRef as ReactComponent };